// extracted by mini-css-extract-plugin
module.exports = {"title__mobile":"EmptyCart_title__mobile__hwlcJ","title__desktop":"EmptyCart_title__desktop__k2mMn","subtitle":"EmptyCart_subtitle__6y92B"};